import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Input, FormGroup, Label, Col } from 'reactstrap';
import { Field } from 'react-final-form';

import 'react-datepicker/dist/react-datepicker.css';
import './index.css';

const formatStr = 'dd/MM/yyyy';

// component for rendering a date select field
const RenderDate = ({
  name,
  label,
  placeholder,
  disabled,
}: {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
}) => (
  <FormGroup row>
    <Label for={name} sm={2}>
      {label}
    </Label>
    <Col sm={10}>
      <Field<Date>
        name={name}
        disabled={disabled}
        placeholder={placeholder}
        validate={(value: Date | undefined) => {
          if (!value) return 'This field is required';
          if (moment(value).isBefore(moment().subtract(120, 'years')))
            return 'The patient must be <120 years old';
          if (moment(value).isAfter(moment().subtract(65, 'years')))
            return 'The patient must be >65 years old';
        }}>
        {({ input, meta, ...rProps }) => {
          const { value, ...rest } = input;
          const dateObj = value ? moment(value).toDate() : null;
          return (
            <div>
              <DatePicker
                {...rest}
                {...rProps}
                dateFormat={formatStr}
                onChange={date => input.onChange(date)}
                showYearDropdown
                showMonthDropdown
                adjustDateOnChange
                maxDate={moment().subtract(65, 'years').toDate()}
                minDate={moment().subtract(120, 'years').toDate()}
                strictParsing
                dropdownMode="select"
                placeholderText="Click to select a date"
                selected={dateObj}
                autoComplete="off"
                customInput={<Input invalid={!!meta.error} />}
              />
              <span
                className={
                  meta.error ? 'text-danger visible' : 'text-danger invisible'
                }>
                {meta.error ? meta.error : 'All good'}
              </span>
            </div>
          );
        }}
      </Field>
    </Col>
  </FormGroup>
);

export default RenderDate;
